import * as React from "react";
const SvgUser = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10M12 14a8 8 0 0 0-8 8h16a8 8 0 0 0-8-8" })));
export default SvgUser;
//# sourceMappingURL=User.js.map